import {useState} from "react";

import WidgetGrid from "../../components/project/Widget.grid/Widget.grid";
import Widgets from "../../components/project/Widget.base/Widget.base";
import LoaderDefault from "../../components/common/Loader.default/Loader.default";
import WidgetFilters from "../../components/project/Widget.filters/Widget.filters";
import { Stack } from "@mantine/core";
import { IWidgetQuery } from "../../api/Base/Base.types";
import WidgetFiltersManager from "../../components/project/Widget.filters/Widget.filters.manager";
import useUserStore from "../../data/User.store";
import { useContainersPerMonth } from "../../api/ContainersPerMonth/ContainersPerMonth.hooks";
import { useTEUByMonth } from "../../api/TEUByMonth/TEUByMonth.hooks";
import { useMonthlyWeightShipped } from "../../api/MonthlyWeightShipped/MonthlyWeightShipped.hooks";
import { useShipmentsPerDay } from "../../api/ShipmentsPerDay/ShipmentsPerDay.hooks";
import {useTopInTransitLanes} from "../../api/TopInTransitLanes/TopInTransitLanes.hooks";
import {
    useShipmentCountByDestinationRegion
} from "../../api/ShipmentCountByDestinationRegion/ShipmentCountByDestinationRegion.hooks";
import {useOnTimeArrival} from "../../api/OnTimeArrival/OnTimeArrival.hooks";
import {useModeOfTransportationBreakdownByMonth} from "../../api/ModeOfTransportationBreakdownByMonth/ModeOfTransportationBreakdownByMonth.hooks";
import {useOnTimeDeparture} from "../../api/OnTimeDeparture/OnTimeDeparture.hooks";

function Dashboard() {
    const [query, setQuery] = useState<IWidgetQuery>(getLocalStorageQuery());
    const {user} = useUserStore();
    const {isLoading: isContainersPerMonthLoading, data: containersPerMonthData} = useContainersPerMonth(query);
    const {isLoading: isTEUByMonthLoading, data: TEUByMonthData} = useTEUByMonth(query);
    const {isLoading: isMonthlyWeightShippedLoading, data: MonthlyWeightShippedData} = useMonthlyWeightShipped(query);
    const {isLoading: isTopInTransitLanesLoading, data: TopInTransitLanesData} = useTopInTransitLanes(query);
    const {isLoading: isShipmentCountByDestinationRegionLoading, data: ShipmentCountByDestinationRegionData} = useShipmentCountByDestinationRegion(query);
    const {isLoading: isOnTimeArrivalLoading, data: OnTimeArrivalData} = useOnTimeArrival(query);
    const {isLoading: isModeOfTransportationBreakdownByMonthLoading, data: ModeOfTransportationBreakdownByMonthData} = useModeOfTransportationBreakdownByMonth(query);
    const {isLoading: isOnTimeDepartureLoading, data: OnTimeDepartureData} = useOnTimeDeparture(query);
    const {isLoading: isShipmentsPerDayLoading, data: ShipmentsPerDayData} = useShipmentsPerDay(query);

    if(
        isContainersPerMonthLoading ||
        isTEUByMonthLoading ||
        isMonthlyWeightShippedLoading ||
        isTopInTransitLanesLoading ||
        isShipmentCountByDestinationRegionLoading ||
        isOnTimeArrivalLoading ||
        isModeOfTransportationBreakdownByMonthLoading ||
        isOnTimeDepartureLoading ||
        isShipmentsPerDayLoading
    ) {
        return (
            <LoaderDefault text="Loading..."/>
        )
    }

    const widgets = [
        {
            Component: Widgets.ContainersPerMonth,
            data: containersPerMonthData
        },
        {
            Component: Widgets.TEUByMonth,
            data: TEUByMonthData
        },
        {
            Component: Widgets.MonthlyWeightShipped,
            data: MonthlyWeightShippedData
        },
        {
            Component: Widgets.TopInTransitLanes,
            data: TopInTransitLanesData
        },
        {
            Component: Widgets.ShipmentCountByDestinationRegion,
            data: ShipmentCountByDestinationRegionData
        },
        {
            Component: Widgets.OnTimeArrival,
            data: OnTimeArrivalData
        },
        {
            Component: Widgets.ModeOfTransportationBreakdownByMonth,
            data: ModeOfTransportationBreakdownByMonthData
        },
        {
            Component: Widgets.ShipmentsPerDay,
            data: ShipmentsPerDayData
        },
        {
            Component: Widgets.OnTimeDeparture,
            data: OnTimeDepartureData
        }
    ]

    function onSubmitQuery(values: IWidgetQuery) {
        let serializedQuery = WidgetFiltersManager
            .setDeserializedValues(values)
            .serializeQuery()
            .setQueryToLocalStorage()
            .setInitialQuerySent()
            .getValues();
        setQuery(serializedQuery);
    }

    function getLocalStorageQuery() {
        return WidgetFiltersManager
            .getQueryFromLocalStorage()
            .getValues();
    }

    function getWidgetFiltersInitialValues() {
        return WidgetFiltersManager
            .setSerializedValues(
                WidgetFiltersManager
                    .getQueryFromLocalStorage()
                    .getValues()
            )
            .deserializeQuery()
            .getValues()
    }

    return (
        <Stack>
            <WidgetFilters onSubmitQuery={onSubmitQuery} initialValues={getWidgetFiltersInitialValues()} user={user}></WidgetFilters>
            <WidgetGrid widgets={widgets}></WidgetGrid>
        </Stack>
    )
}

export default Dashboard;